import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import { NavLink } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './DataSecurity.css';


const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};


const DataSecurity = () => {
  const [showModal, setShowModal] = useState(true);
    const [hasPaidTrue, setHasPaidTrue] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
  
    const getUserId = () => {
      const user = auth.currentUser;
      return user?.uid;
    };
  
    const fetchHasPaidTrue = async () => {
      try {
        const userId = getUserId();
        if (!userId) return;
  
        const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
        const userDocSnapshot = await getDocs(userDocQuery);
  
        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          const getHasPaid = userDocData.HasPaid || false;
          setHasPaidTrue(getHasPaid);
        } else {
          console.log('User document not found');
          setHasPaidTrue(false); // default to false if not found
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setHasPaidTrue(false);
      }
    };
  
    useEffect(() => {
      fetchHasPaidTrue();
    });
  
    const isDisabled = hasPaidTrue === false;
    const handleContactClick = () => {
      setShowModal(false);
      setShowContactModal(true);
    };
  return (
    <div className='secBG'>
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}
      <div className='SecurityMainContent'>
        <div className='Security-container'>
          <div className='security-card-accent'/>
          <br/>
          <img src="DataVaults.png" alt="Logo" className='Secur-image' />
          <div className='textContent'>
            <h2 className='headingcenter'>Secure, Anonymise, Innovate – Privacy-First Data for Responsible AI.</h2>
            {/*<p className='textCenter'>A suite of tools for a customised, end-to-end responsible AI experience</p>*/}
            <div className='SecurityContainer'>
              <div className='Security2'>
                <div className='securitycolumns'>
                  <h2>What is DataVaults?</h2>
                  <p>DataVaults is designed to enhance privacy and security when handling sensitive datasets. It employs advanced anonymisation techniques, including data obfuscation (such as masking, pseudonymization, and generalization) and K-Anonymity, ensuring that individuals cannot be re-identified even when datasets are shared or analyzed. To further protect privacy, DataVaults enables users to generate synthetic datasets that mimic the statistical properties of the original data without exposing any real records. This allows organizations to safely use derived datasets for machine learning model training, eliminating the risk of privacy breaches. Additionally, DataVaults includes image and video anonymization, automatically detecting and obscuring faces to prevent identity disclosure in visual data.</p>
                </div>
                <div className='securitycolumns'>
                  <h2>Why DataVaults?</h2>
                  <p>By integrating robust privacy-preserving measures, DataVaults supports the development of Trusted and Responsible AI. It mitigates risks associated with data misuse, ensuring compliance with regulations like GDPR while fostering ethical data practices. The ability to create synthetic datasets reduces reliance on raw sensitive data, minimizing exposure to leaks or adversarial attacks. Meanwhile, automated face obscuration in images and videos helps organizations uphold privacy standards in surveillance, healthcare, and public datasets. Ultimately, DataVaults empowers businesses and researchers to innovate with AI responsibly—balancing data utility with strong privacy safeguards, promoting transparency, and building trust with end-users and stakeholders.</p>
                </div>
              </div>
              <br/>
              {/* {hasPaidTrue && (
                <div className='button-group'>
                  <a href="https://trams.assentian.com" target="_blank">
                      <button className="download-button" disabled={isDisabled}>DataVaults</button>
                  </a>
                </div>
              )} */}
              <div className='button-group'>
                <NavLink 
                  to="/ContactUs" 
                >
                  <button className='download-button' >Contact Us</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataSecurity;

